import { useLocation } from "react-router-dom";
import { PAGE_FAQS } from "../content/pageFaqs";
import { FaqList } from "./FaqList";

// Visible FAQ block for index and tool pages; the same pairs are injected as FAQPage JSON-LD by lib/seo.
export function PageFaqs() {
  const { pathname } = useLocation();
  const items = PAGE_FAQS[pathname.replace(/\/+$/, "") || "/"];
  if (!items) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 lg:px-8" aria-labelledby="page-faq-h" data-testid="page-faqs">
      <h2 id="page-faq-h" className="text-base font-semibold md:text-lg">Frequently asked questions</h2>
      <FaqList items={items} className="mt-4" testId="page-faq-list" itemTestId="page-faq" />
    </section>
  );
}
